import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { MAlert, SampleDocumentDownloadLink } from 'src/lib';
import { Font, Heading, Spacing } from 'src/styles';

interface AccountApplicationCategoryHeaderProps {
  title: string;
  note?: string;
  description?: string;
  sampleDocument?: {
    text: string;
    link: string;
  };
  testId?: string;
}

export const AccountApplicationCategoryHeader = ({
  title,
  description,
  note,
  sampleDocument,
  testId,
}: AccountApplicationCategoryHeaderProps) => {
  return (
    <Row>
      <Col span={24} className={Spacing.my4}>
        <div>
          <div className={Heading.title3} data-testid={testId + '-title-section'}>
            {title}
          </div>
          {description && (
            <div className={Heading.subtitle} data-testid={testId + '-description-section'}>
              {description}
            </div>
          )}
        </div>
      </Col>
      {note && (
        <Col span={24} className={Spacing.my4}>
          <MAlert type='warning' description={note} className={Spacing.mx0} testId={testId + '-alert-description'} />
        </Col>
      )}
      {sampleDocument && (
        <Col span={24} className={cx(Spacing.mt4, Spacing.mb12)}>
          <SampleDocumentDownloadLink
            text={sampleDocument.text}
            link={sampleDocument.link}
            className={Font.lg}
            testId={'sample'}
          />
        </Col>
      )}
    </Row>
  );
};
